<div class="progress">
    @if(data.excellent.value > 0){
        <div class="progress-bar progress-bar-excellent"
             [ngStyle]="{'width': data.excellent.percentage}"
             [matTooltip]="data.excellent.label + ' (' + data.excellent.number + ')'"
             matTooltipPosition="above">
           {{ 'excellent' | translate }}
       </div>
    }
    @if(data.good.value > 0){
        <div class="progress-bar progress-bar-good" 
             [ngStyle]="{'width': data.good.percentage}"
             [matTooltip]="data.good.label + ' (' + data.good.number + ')'"
             matTooltipPosition="above">
           {{ 'good' | translate }}
       </div>
    }
    @if(data.average.value > 0){
        <div class="progress-bar progress-bar-average" 
             [ngStyle]="{'width': data.average.percentage}"
             [matTooltip]="data.average.label + ' (' + data.average.number + ')'"
             matTooltipPosition="above">
           {{ 'average' | translate }}
       </div>
    }
    @if(data.hard.value > 0){
        <div class="progress-bar progress-bar-hard" 
             [ngStyle]="{'width': data.hard.percentage}"
             [matTooltip]="data.hard.label + ' (' + data.hard.number + ')'"
              matTooltipPosition="above">
           {{ 'hard' | translate }}
       </div>
    }
    @if(data.bad.value > 0){
        <div class="progress-bar progress-bar-bad" 
             [ngStyle]="{'width': data.bad.percentage}"
             [matTooltip]="data.bad.label + ' (' + data.bad.number + ')'"
             matTooltipPosition="above">
           {{ 'bad' | translate }}
       </div>
    }
</div>


